export enum Role {
  Org_User = "Org_User",
  Org_Admin = "Org_Admin",
  Org_SuperAdmin = "Org_SuperAdmin",
}
